import { useEffect } from "react";
import { useFieldArray, useFormContext, useFormState } from "react-hook-form";
import { Box, Grid, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { Button } from "react-admin";
import { AttestationStatus } from "utils/constants";
import { attestationColumns } from "./columns";
import DisciplineBlock from "./DisciplineBlock";

const SaveSemesterButton = () => {
  const { isSubmitting } = useFormState();

  return (
    <Button
      type="submit"
      label="Запази заверките"
      variant="contained"
      size="medium"
      startIcon={<SaveIcon />}
      disabled={isSubmitting}
    />
  );
};

const SemesterAttestationsForm = ({ disciplines, rows, canManage }) => {
  const { control, reset } = useFormContext();
  // `id` is our attestation id, so the generated key has to live under another name.
  const { fields, append, remove } = useFieldArray({ control, name: "attestations", keyName: "fieldKey" });

  // The page refetches after every save, so the form is re-seeded with the fresh server state.
  useEffect(() => {
    reset({ attestations: rows });
  }, [rows, reset]);

  const rowsOfDiscipline = disciplineId =>
    fields.map((field, index) => ({ field, index })).filter(row => row.field.disciplineId === disciplineId);

  // A new row inherits the semester from the accordion it is added in - the backend takes it from the URL.
  const addRow = disciplineId =>
    append({
      id: null,
      disciplineId,
      classTypeId: null,
      status: AttestationStatus.AwaitingVerification,
      professorEmployeeId: null,
      note: "",
    });

  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{ display: { xs: "none", md: "flex" }, mb: 1 }}
      >
        {Object.values(attestationColumns).map(column => (
          <Grid
            item
            key={column.label}
            md={column.md}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold" }}
            >
              {column.label}
            </Typography>
          </Grid>
        ))}
      </Grid>
      {disciplines.map(discipline => (
        <DisciplineBlock
          key={discipline.disciplineId}
          discipline={discipline}
          rows={rowsOfDiscipline(discipline.disciplineId)}
          canManage={canManage}
          onAdd={addRow}
          onRemove={remove}
        />
      ))}
      {canManage && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <SaveSemesterButton />
        </Box>
      )}
    </>
  );
};

export default SemesterAttestationsForm;
